<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人" v-trim/>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="车辆类型编码（关联base_param)" prop="paramId">
        <el-input v-model="form.paramId" placeholder="请输入车辆类型编码（关联base_param)" v-trim/>
      </el-form-item>
      <el-form-item label="编号" prop="code">
        <el-input v-model="form.code" placeholder="请输入编号" v-trim/>
      </el-form-item>
      <el-form-item label="状态 0停车可出借 1出借中 3禁用 " prop="status">
        <el-input v-model="form.status" placeholder="请输入状态 0停车可出借 1出借中 3禁用 " v-trim/>
      </el-form-item>
      <el-form-item label="当前站点编码（关联sites)" prop="siteId">
        <el-input v-model="form.siteId" placeholder="请输入当前站点编码（关联sites)" v-trim/>
      </el-form-item>
      <el-form-item label="当前锁头编码（关联locks)" prop="lockId">
        <el-input v-model="form.lockId" placeholder="请输入当前锁头编码（关联locks)" v-trim/>
      </el-form-item>
      <el-form-item label="最近租借时间" prop="lastRentData">
        <el-date-picker v-model="form.lastRentData" value-format="yyyy-MM-dd" placeholder="请输入最近租借时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="出售时间" prop="soldoutDate">
        <el-date-picker v-model="form.soldoutDate" value-format="yyyy-MM-dd" placeholder="请输入出售时间"></el-date-picker>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaBikesWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        name: '',
        info: '',
        paramId: '',
        code: '',
        status: '',
        siteId: '',
        lockId: '',
        lastRentData: '',
        soldoutDate: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/bikes',
      'field.id': 'id'
    })
  }
}
</script>
